const svg = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.9" d="M15.709 9.7501C15.709 9.7501 6.01921 9.7501 2.29126 9.7501C2.66435 6.37512 5.52567 3.75006 9.00011 3.75006C12.4745 3.75006 15.3359 6.37512 15.709 9.7501Z" fill="white"/>
<path opacity="0.9" d="M17.2501 10.5001H0.75M12.7501 13.8751H5.25003M15.0001 17.2501H9.75006" stroke="white" strokeWidth="1.50001" strokeLinecap="round"/>
</g>
</svg>`;

export default svg;
